export const NODES_CHAIN = [
    { label: "ASSET" },
    { label: "POOL" },
    { label: "VAULT" },
    { label: "USDC", gold: true },
    { label: "ARC", gold: true },
];

export const CASH_LANES = [
    { id: "property", src: "PROPERTY", event: "RENT" },
    { id: "invoice", src: "INVOICE", event: "PAYMENT" },
    { id: "loan", src: "LOAN", event: "INTEREST" },
];
